"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundCheckStatus = void 0;
exports.instanceOfBackgroundCheckStatus = instanceOfBackgroundCheckStatus;
exports.BackgroundCheckStatusFromJSON = BackgroundCheckStatusFromJSON;
exports.BackgroundCheckStatusFromJSONTyped = BackgroundCheckStatusFromJSONTyped;
exports.BackgroundCheckStatusToJSON = BackgroundCheckStatusToJSON;
exports.BackgroundCheckStatusToJSONTyped = BackgroundCheckStatusToJSONTyped;
/**
 *
 * @export
 */
exports.BackgroundCheckStatus = {
    Unsubmitted: 'UNSUBMITTED',
    Processing: 'PROCESSING',
    Authorized: 'AUTHORIZED',
    PendingReview: 'PENDING_REVIEW',
    Unauthorized: 'UNAUTHORIZED'
};
function instanceOfBackgroundCheckStatus(value) {
    for (const key in exports.BackgroundCheckStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.BackgroundCheckStatus, key)) {
            if (exports.BackgroundCheckStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BackgroundCheckStatusFromJSON(json) {
    return BackgroundCheckStatusFromJSONTyped(json, false);
}
function BackgroundCheckStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BackgroundCheckStatusToJSON(value) {
    return value;
}
function BackgroundCheckStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=BackgroundCheckStatus.js.map